import onlyNumbersParser from './onlyNumbersParser'
import numberWithOneDotParser from './numberWithOneDotParser'
import dataNascimentoParser from './dataNascimentoParser'

export default {
    onlyNumbers: onlyNumbersParser,
    numberWithOneDot: numberWithOneDotParser,
    dataNascimento: dataNascimentoParser,
}